import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background-color: ${theme.v2.colors.neutral.highPure};
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: flex-start;
    max-width: 738px;
  `}
`;

export const HeadWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 8px;
    margin: 48px 0 32px 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      margin: 48px 0 24px 0;
    }
  `}
`;

export const IconCircle = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${theme.v2.colors.brand.primaryUltraLight};
    border-radius: 50%;
    height: 32px;
    width: 32px;
  `}
`;

export const Title = styled.h2`
  ${({ theme }) => css`
    color: ${theme.v2.colors.brand.primaryExtraDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.sm2};
    }
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    line-height: ${theme.v2.font.lineHeight.description};
    margin: 8px 0;
    @media (max-width: ${theme.v2.breakpoints.md}) {
      font-size: ${theme.v2.font.sizes.xxs};
    }
  `}
`;

export const ButtonsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    margin: 40px 0 0 0;
    gap: 16px;
    justify-content: space-between;

    path {
      stroke-width: 4px;
    }
    @media (max-width: ${theme.v2.breakpoints.md}) {
      flex-direction: column;
      button:first-child {
        order: 2
      }
    }
  `}
`;
